// Capacity guidance for converting at original quality.
//
// This is meaningfully heavier than the transcription tool's numbers
// (src/utils/transcriptExports.js): Whisper only ever needs 16 kHz mono, but a
// faithful conversion keeps the source's real channel count and sample rate.
// Stereo 44.1/48 kHz float32 is roughly 350 KB/sec — about 5-6x the 64 KB/sec
// transcription budgets for, so an hour of ordinary stereo music-quality audio
// is over a gigabyte in memory while it's being processed.
//
// Nothing here is a hard technical cap; they are the points where a browser
// tab starts to struggle.

/** Past this, `file.arrayBuffer()` itself is likely to fail outright. */
export const MAX_FILE_BYTES = 2 * 1024 * 1024 * 1024;

/** Peak memory for one file's decoded samples, in bytes (float32, uncompressed). */
export function originalDecodedBytes(durationSeconds, channels, sampleRate) {
  return Math.round((durationSeconds || 0) * (channels || 1) * (sampleRate || 0) * 4);
}

// Thresholds are expressed in decoded bytes, not duration, because the same
// warning should fire earlier for 48 kHz stereo than for 8 kHz mono telephony.
export const LONG_DECODED_BYTES = 500 * 1024 * 1024;        // ~500 MB
export const VERY_LONG_DECODED_BYTES = 1.5 * 1024 * 1024 * 1024; // ~1.5 GB

export function fmtBytes(n) {
  if (!n && n !== 0) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}
